// Hero de la page liste des articles

const BlogHero = () => {
  return (
    <section className="relative py-16 pt-28 bg-[#0F172A]">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Le Blog B<span className="text-[#F59E0B]">8</span>ild
          </h1>
          <p className="text-lg text-white/60 leading-relaxed">
            Conseils, actualites et guides pour optimiser la rentabilite de vos chantiers BTP.
          </p>
        </div>
      </div>

      {/* Gradient de fond subtil */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#F59E0B]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#3B82F6]/5 rounded-full blur-3xl" />
      </div>
    </section>
  );
};

export default BlogHero;
